import type { ICellRendererParams } from 'ag-grid-community';
import type { Forecast } from '../../schema';

// Two-line cell: bold "Crop · Variety" + muted APMC subtitle. Compact way to
// surface the price-series identity trinity in one column.
export function ForecastSeriesCell(p: ICellRendererParams<Forecast>) {
  if (!p.data) return null;
  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">
        {p.data.cropName} · {p.data.varietyName}
      </span>
      <span className="mt-0.5 text-[11px] text-foreground-muted">
        {p.data.apmcName}
      </span>
    </div>
  );
}
